import "./style.css";
import React, { useEffect } from "react"
import AppProvider from "./hooks";
import { Routes } from "./routes";
import { Toaster } from "react-hot-toast";
import { BrowserRouter } from "react-router-dom";
import AppWebCheckinUserProvider from "./hooks/WebCheckinUsers";
import { WebCheckinUserRoutes } from "./routes/webCheckinUserRoutes";

export const App: React.FC = () => {
  const isCheckinRoute = location.pathname === '/checkin'
  const isCheckoutRoute = location.pathname === '/checkout';

  const isWebCheckinUser = isCheckinRoute || isCheckoutRoute;

  return (
    <BrowserRouter>

      {!isWebCheckinUser && (
        <AppProvider>
          <Routes />
          <Toaster />
        </AppProvider>
      )}

      {isWebCheckinUser && (
        <AppWebCheckinUserProvider>
          <WebCheckinUserRoutes />
          <Toaster />
        </AppWebCheckinUserProvider>
      )}

    </BrowserRouter>
  );
}